import React from 'react';
import ReactDOM from 'react-dom';
import {DOM_ID} from '../../../../../constants';

const styles: {[key: string]: React.CSSProperties} = {
  container: {
    zIndex: 30,
    position: 'absolute',
    top: '145px',
    right: '10px',
  },
};

export function PluAutoNotificationsContainer(): React.ReactElement {
  return (
    <div id={DOM_ID.pluAutoNotificationsContainer} style={styles.container} />
  );
}

type PluAutoNotificationsPortalProps = {
  children: React.ReactElement;
};

export default function PluAutoNotificationsPortal({
  children,
}: PluAutoNotificationsPortalProps): React.ReactPortal | null {
  const container = document.getElementById(
    DOM_ID.pluAutoNotificationsContainer,
  );

  if (!container) {
    return null;
  }

  return ReactDOM.createPortal(children, container);
}
